import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mockData';

const Testimonials = () => {
  // Duplicate testimonials for seamless infinite scroll
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <section id="testimonials" className="py-24 bg-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 right-10 w-96 h-96 bg-cyan-200 rounded-full filter blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 mb-12">
        <div className="text-center">
          <div className="text-cyan-800 text-sm font-semibold tracking-wider uppercase mb-4">
            CLIENT TESTIMONIALS
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Don't just take our word for it—hear from homeowners who've transformed their spaces
          </p>
        </div>
      </div>

      {/* Auto-scrolling Testimonials */}
      <div className="relative w-full overflow-hidden mb-12">
        <div 
          className="flex gap-6 animate-scroll-testimonials"
          style={{
            width: 'max-content',
          }}
        >
          {duplicatedTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-96 bg-white rounded-2xl p-6 border-2 border-cyan-700/30 hover:border-cyan-700 hover:shadow-xl transition-all duration-300 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 opacity-10">
                <Quote className="w-12 h-12 text-cyan-800" />
              </div>

              {/* Avatar & Name */}
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 bg-cyan-800 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg shadow-cyan-800/30">
                  {testimonial.avatar}
                </div>
                <div>
                  <h4 className="text-gray-900 font-bold text-lg">{testimonial.name}</h4>
                  <p className="text-gray-500 text-sm">{testimonial.location}</p>
                </div>
              </div>

              {/* Stars */}
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>

              {/* Review */}
              <p className="text-gray-600 text-base leading-relaxed mb-4 line-clamp-4">
                "{testimonial.review}"
              </p>

              {/* Service Tag */}
              <div className="flex items-center gap-2 mt-auto pt-4 border-t border-cyan-100">
                <span className="text-sm text-cyan-800 font-semibold">{testimonial.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Rating Banner */}
      <div className="text-center relative z-10">
        <div className="inline-flex items-center gap-4 bg-white rounded-full px-8 py-4 border-2 border-cyan-700 shadow-lg">
          <div className="flex items-center gap-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
            ))}
          </div>
          <div className="h-8 w-px bg-cyan-700"></div>
          <div className="text-left">
            <div className="text-2xl font-bold text-cyan-800">5/5</div>
            <div className="text-xs text-gray-600">From 57 Reviews on Google</div>
          </div>
        </div>
      </div>

      {/* CSS Animation */}
      <style jsx>{`
        @keyframes scrollTestimonials {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll-testimonials {
          animation: scrollTestimonials 40s linear infinite;
        }
        .animate-scroll-testimonials:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Testimonials;
